/**
 * Promise-based confirm dialog store.
 *
 * Allows imperative code (e.g. context menu handlers) to show
 * an AlertDialog and await the user's response.
 */

import { create } from 'zustand';

type ConfirmDialogState = {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  resolve: ((value: boolean) => void) | null;
  requestConfirm: (title: string, description: string, confirmLabel?: string) => Promise<boolean>;
  confirm: () => void;
  cancel: () => void;
};

export const useConfirmDialogStore = create<ConfirmDialogState>((set, get) => ({
  open: false,
  title: '',
  description: '',
  confirmLabel: 'Delete',
  resolve: null,
  requestConfirm: (title, description, confirmLabel = 'Delete') =>
    new Promise((resolve) => {
      set({ open: true, title, description, confirmLabel, resolve });
    }),
  confirm: () => {
    get().resolve?.(true);
    set({ open: false, resolve: null });
  },
  cancel: () => {
    get().resolve?.(false);
    set({ open: false, resolve: null });
  },
}));
